import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface AuditLogEntry {
  id: number;
  model: string;
  record_id: number;
  operation: 'insert' | 'update' | 'delete';
  changes: { [field: string]: [any, any] } | null;
  change_labels?: { [field: string]: [string | null, string | null] } | null;
  created_at: string;
  created_by?: number | null;
  created_by_label?: string | null;
}

export interface FieldChangeRow {
  id: number;
  changed_at: string;
  operation: string;
  field: string;
  oldValue: any;
  newValue: any;
  created_by?: number | null;
  created_by_label?: string | null;
}

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  constructor(private http: HttpClient) {}

  fetch(model: string, recordId: number): Observable<AuditLogEntry[]> {
    const params = new HttpParams().set('model', model).set('record_id', recordId);
    return this.http
      .get<{ data: AuditLogEntry[] }>(`${environment.api}audit/history`, { params })
      .pipe(map((r) => r.data || []));
  }

  flatten(entries: AuditLogEntry[]): FieldChangeRow[] {
    const rows: FieldChangeRow[] = [];
    for (const e of entries) {
      if (!e.changes) {
        rows.push({
          id: e.id,
          changed_at: e.created_at,
          operation: e.operation,
          field: '(no fields)',
          oldValue: '',
          newValue: '',
          created_by: e.created_by,
          created_by_label: e.created_by_label ?? null,
        });
        continue;
      }
      Object.entries(e.changes).forEach(([field, [oldV, newV]]) => {
        const lbl = e.change_labels && e.change_labels[field];
        if (lbl) {
          oldV = lbl[0] !== null ? lbl[0] : oldV;
          newV = lbl[1] !== null ? lbl[1] : newV;
        }
        rows.push({
          id: e.id,
          changed_at: e.created_at,
          operation: e.operation,
          field,
          oldValue: oldV,
          newValue: newV,
          created_by: e.created_by,
          created_by_label: e.created_by_label ?? null,
        });
      });
    }
    rows.sort((a, b) => b.id - a.id);
    return rows;
  }
}
